module.exports = __webpack_public_path__ + "img/Group 999two.d57b0d55.png";